import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [dark, setDark] = useState(true);
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch('https://api.mogym.ir/api/admin/summary', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
        });
        const data = await res.json();
      if (!res.ok) {
          navigate('/admin/login');
          return;
  
      }
        
        setStats(data.Result);
      } catch (ex) {
    localStorage.removeItem('admin_token');
              navigate('/admin/login');

        setError(ex.message ||'دریافت آمار کلی با خطا مواجه شد.');
      }
    };

    fetchStats();
  }, []);

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-8 font-vazir">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center">پنل مدیریت موجیم</h1>

          {error && <div className="text-red-500 text-center">{error}</div>}

          {stats && (
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6 text-center">
              <div className="bg-blue-100 dark:bg-blue-900 rounded-xl p-4">
                <p className="text-sm">کل برنامه‌ها</p>
                <p className="text-lg font-bold">{stats.TotalPlans}</p>
              </div>
              <div className="bg-green-100 dark:bg-green-900 rounded-xl p-4">
                <p className="text-sm">پرداخت‌شده</p>
                <p className="text-lg font-bold">{stats.PaidPlans}</p>
              </div>
              <div className="bg-yellow-100 dark:bg-yellow-800 rounded-xl p-4">
                <p className="text-sm">در انتظار پرداخت</p>
                <p className="text-lg font-bold">{stats.PendingPlans}</p>
              </div>
                <div className="bg-red-100 dark:bg-purple-900 rounded-xl p-4">
                <p className="text-sm">ساخته شده</p>
                <p className="text-lg font-bold">{stats.CreatedPlans}</p>
              </div>
              <div className="bg-red-100 dark:bg-red-900 rounded-xl p-4">
                <p className="text-sm">لغو شده</p>
                <p className="text-lg font-bold">{stats.CanceledPlans}</p>
              </div>
            </div>
          )}

          {stats && (
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <button
                onClick={() => navigate('/admin/plans')}
                className="bg-blue-200 dark:bg-blue-800 text-blue-900 dark:text-white rounded-xl py-4 px-2 shadow hover:scale-105 transition"
              >
                📦 مدیریت برنامه‌ها
              </button>
              <button
                onClick={() => navigate('/admin/users')}
                className="bg-green-200 dark:bg-green-800 text-green-900 dark:text-white rounded-xl py-4 px-2 shadow hover:scale-105 transition"
              >
                👤 کاربران
              </button>
              <button
                onClick={() => navigate('/admin/feedbacks')}
                className="bg-purple-200 dark:bg-purple-800 text-purple-900 dark:text-white rounded-xl py-4 px-2 shadow hover:scale-105 transition"
              >
                💬 بازخوردها
              </button>
<button
  onClick={() => navigate('/admin/videoReports')}
  className="bg-orange-200 dark:bg-orange-800 text-orange-900 dark:text-white rounded-xl py-4 px-2 shadow hover:scale-105 transition"
>
  📼 گزارش ویدیوها
</button>

            </div>
          )}
        </div>

        {/* کلید روشن/تیره */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
